export { AnimatedSubtitle } from './animated-subtitle'
